import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Button } from 'uiToolkitV1/Button';
import { InputV2 } from 'uiToolkitV1/InputV2';
import { Select } from 'uiToolkitV1/Select';
import { TabList } from 'uiToolkitV1/Tabs';

export const StyledSelect = styled(Select)`
  .chakra-text {
    color: #666666;
    padding-bottom: 0.5rem;
  }

  .select {
    width: 100%;
  }

  .select__control {
    border: none;
  }
`;

export const StyledInput = InputV2;

export const VisibilitySwitch = styled(Button)`
  padding: 0;
  height: 24px;
`;

export const VisibilitySwitchDisabled = styled(Button)`
  padding: 0;
  height: 24px;

  p {
    color: #666666;
  }
`;

export const StyledTabList = styled(TabList)`
  /* background-color: white; */
  box-shadow: none;
  ${(props) =>
    props.hideTabs &&
    css`
      display: none;
    `};
`;
export const StyledMultiSelectMenu = styled(Select)`
  margin: 2px;
`;
